import React, { useState, useContext } from 'react';
import { Row } from '@thd-olt-component-react/core-ui';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import {
  string, arrayOf, shape, bool, number
} from 'prop-types';
import { CustomProductPod } from './CustomProductPod';
import { ProductSetContext } from '../../context/ProductSetContext';
import { QuickViewWrapper } from '../QuickViewWrapper/QuickViewWrapper';
import { SwapBack } from '../SwapBack/SwapBack';
import { RadioButtons } from '../RadioButtons/RadioButtons';
import { LoaderOverlay } from '../Loader/LoaderOverlay';
import './product-pod-container.scss';

export const ProductPodContainer = ({
  position,
  products,
  productGroup,
  showCTA,
  isLoading
}) => {

  const [quickViewOpen, setQuickViewOpen] = useState(false);
  const { isMobile, storeId } = useContext(ProductSetContext);
  const { defaultVariables } = useContext(QueryContext) || {};

  const quickViewClickHandler = (event) => {
    event.preventDefault();
    setQuickViewOpen(true);
  };

  const activeProduct = products.find((product) => product.active);

  const newDefaultVariables = {
    storeId,
    skipInstallServices: true,
    skipSpecificationGroup: false,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <>
      <Row
        data-testid="product-pod-container"
        className="product-pod-container"
      >
        <QuickViewWrapper
          itemId={activeProduct.itemId}
          isQuickViewOpen={quickViewOpen}
          onQuickViewClose={() => setQuickViewOpen(false)}
        >
          <LoaderOverlay isLoading={isLoading} />
          {!!activeProduct.swappedProducts.length && (
            <SwapBack
              swappedProducts={activeProduct.swappedProducts}
              productGroup={productGroup}
            />
          )}
          <QueryProvider
            cacheKey="product-pod-container"
            dataSource={activeProduct.dataSources}
            defaultVariables={newDefaultVariables}
          >
            <CustomProductPod
              index={position}
              itemId={activeProduct.itemId}
              storeId={storeId}
              onClick={quickViewClickHandler}
              showCTA={showCTA}
              productGroup={productGroup}
              products={products}
            />
          </QueryProvider>
        </QuickViewWrapper>
        {!isMobile && products.length > 1
          && (
            <RadioButtons
              products={products}
              productGroup={productGroup}
            />
          )}
      </Row>
    </>
  );
};

ProductPodContainer.propTypes = {
  position: number.isRequired,
  products: arrayOf(shape({})).isRequired,
  productGroup: string.isRequired,
  showCTA: bool.isRequired,
  isLoading: bool
};

ProductPodContainer.defaultProps = {
  isLoading: false
};
